<div class="d-flex">
    <div class="du-sidebar-visiblity" [class.du-side-bar-display]="isExpanded"><app-user-menu (onSelect)="selectModule($event)" (sidebarSize)="sidebarSizeEvent($event)"></app-user-menu></div>
    <div [class.du-side-bar-size-desktop]="!sideBarStacked" class="du-changeWidthbody"><router-outlet></router-outlet></div>
</div>